import Vue from "vue";
import Router from "vue-router";

import Login from "@/views/Login";
import Home from "@/views/Home";
import My from "@/views/My";

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

export default new Router({
    routes: [{
        path: "/Login",
        name: "Login",
        component: Login,
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/My",
        name: "My",
        component: My,
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/User",
        name: "User",
        component: resolve => require(['@/components/User'], resolve),
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/Collection",
        name: "Collection",
        component: resolve => require(['@/components/Collection'], resolve),
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/WrongTopic",
        name: "WrongTopic",
        component: resolve => require(['@/components/WrongTopic'], resolve),
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/RandomExercise",
        name: "RandomExercise",
        component: resolve => require(['@/components/RandomExercise'], resolve),
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/ChapterExercise",
        name: "ChapterExercise",
        component: resolve => require(['@/components/ChapterExercise'], resolve),
        meta: {
            keepAlive: false
        },
    },
    {
        path: "/ExamResult",
        name: "ExamResult",
        component: resolve => require(['@/components/ExamResult'], resolve),
        meta: {
            keepAlive: false
        },
    },
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js